import React, { useEffect, useRef } from "react";

// Restrained cursor-reactive ambient glow (pointer-events-none), premium-agency feel.
export const CursorGlow = () => {
  const ref = useRef(null);
  const raf = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const el = ref.current;
    let tx = window.innerWidth / 2, ty = window.innerHeight * 0.3;
    let cx = tx, cy = ty;

    const onMove = (e) => { tx = e.clientX; ty = e.clientY; };
    window.addEventListener("pointermove", onMove);

    const tick = () => {
      cx += (tx - cx) * 0.08;
      cy += (ty - cy) * 0.08;
      if (el) {
        el.style.setProperty("--glow-x", `${cx}px`);
        el.style.setProperty("--glow-y", `${cy}px`);
      }
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("pointermove", onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return <div ref={ref} className="cursor-glow pointer-events-none fixed inset-0 z-0" aria-hidden="true" />;
};

export default CursorGlow;
